import SchedulerExamDaySteps from "../SchedulerExamDaySteps";
import FormGridCell from "../../common/FormGridCell";
import Grid from "@material-ui/core/Grid";
import React, { FC, useContext } from "react";
import TitleWithIcon from "../../common/TitleWithIcon";
import SchedulerTable from "../SchedulerTable";
import { SchedulerContextValue } from "../context/SchedulerContext";
import { AssignmentInd } from "@material-ui/icons";

const ExpertScheduler: FC = () => {
  const { examSessionLabel, selectedExamDayId, locations, examDays, changeSelectedExamDay } =
    useContext(SchedulerContextValue);

  return (
    <Grid container={true} alignItems="baseline">
      <FormGridCell size="wide">
        <TitleWithIcon title={examSessionLabel} variant="h4">
          <AssignmentInd />
        </TitleWithIcon>
      </FormGridCell>
      <FormGridCell size="wide">
        <SchedulerExamDaySteps
          locations={locations}
          showLocation={true}
          selectedExamDayId={selectedExamDayId}
          examDays={examDays}
          onExamDaySelected={changeSelectedExamDay}
        />
      </FormGridCell>
      <FormGridCell size="wide">
        <SchedulerTable />
      </FormGridCell>
    </Grid>
  );
};

export default ExpertScheduler;
